<script setup lang="ts">
  import { useSearchCriteria } from '@/entities/searchCriteria';
  import { TourSearch } from '@/entities/tour';
  import type { SwitchCity } from '@/features/switchCity';
  import { provideSerp, SerpLayoutMobile } from '@/layouts/serp';
  import { FormDataUrl, IntelligentSearchUrl, CountryResortsUrl } from '@/shared/config/formData';
  import { LocalStorageKey } from '@/shared/config/localStorage';
  import type { PageContent } from '@/shared/config/pages';
  import ClientOnly from '@/shared/ui/ClientOnly.vue';
  import { SerpBanners } from '@/widgets/banners';

  interface SearchMobileProps {
    cities?: SwitchCity[];
    currentCity?: SwitchCity | null;
    isVisibleRoomButton?: boolean;
    pageContent?: PageContent;
  }

  withDefaults(defineProps<SearchMobileProps>(), {
    cities: () => [],
    currentCity: null,
    isVisibleRoomButton: true,
    pageContent: undefined,
  });

  interface SearchMobileEmits {
    (e: 'chat'): void;
    (e: 'change:city', city: SwitchCity): void;
  }

  const emit = defineEmits<SearchMobileEmits>();

  const searchCriteria = useSearchCriteria({
    withHistory: true,
    withPrices: true,
    lastCriteriaKey: LocalStorageKey.TourCriteria,
    formUrl: FormDataUrl.Tours,
    searchUrl: IntelligentSearchUrl.Tours,
    resortsUrl: CountryResortsUrl.Tours,
  });

  const productSearch = new TourSearch();

  provideSerp({
    useSearchCriteria: () => searchCriteria,
    productSearch,
  });
</script>

<template>
  <div class="search-mobile">
    <SerpLayoutMobile
      :cities="cities"
      :current-city="currentCity"
      :is-visible-room-button="isVisibleRoomButton"
      :page-content="pageContent"
      @chat="emit('chat')"
      @change:city="emit('change:city', $event)"
    >
      <template
        #banner="{
          product,
          searchCriteria: criteria,
          cardPosition,
          totalCards,
          isAlternativeSearch,
          isShortSerp,
          searchEmirates,
        }"
      >
        <ClientOnly>
          <SerpBanners
            :product="product"
            :search-criteria="criteria"
            :card-position="cardPosition"
            :total-cards="totalCards"
            :is-alternative-search="isAlternativeSearch"
            :is-short-serp="isShortSerp"
            @emirates="searchEmirates"
          />
        </ClientOnly>
      </template>
    </SerpLayoutMobile>
  </div>
</template>
